import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

function LanguageSwitcher() {
const { i18n, t } = useTranslation();
const [fontSize, setFontSize] = useState('normal');

// Ensure lang attribute is set correctly on mount
useEffect(() => {
document.documentElement.lang = i18n.language;
}, [i18n.language]);

const changeLanguage = (lng) => {
i18n.changeLanguage(lng);
document.documentElement.lang = lng;
};

const changeFontSize = (size) => {
setFontSize(size);
const root = document.documentElement;
switch (size) {
case 'small':
root.style.fontSize = '14px';
break;
case 'normal':
root.style.fontSize = '18px';
break;
case 'large':
root.style.fontSize = '20px';
break;
case 'xl':
root.style.fontSize = '19px';
break;
default:
root.style.fontSize = '16px';
}
};

return ( <div className="flex items-center space-x-1">
{/* Text Size Controls */}
<button
onClick={() => changeFontSize('large')}
className={`px-1 py-0.5 text-xs font-medium rounded border transition-all duration-200 ${
          fontSize === 'large'
            ? 'bg-gray-300 text-gray-800 border-gray-400'
            : 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'
        }`}
title={t('accessibility.fontSize.increase')}
>
A+ </button>
<button
onClick={() => changeFontSize('normal')}
className={`px-1 py-0.5 text-xs font-medium rounded border transition-all duration-200 ${
          fontSize === 'normal'
            ? 'bg-gray-300 text-gray-800 border-gray-400'
            : 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'
        }`}
title={t('accessibility.fontSize.normal')}
>
A= </button>
<button
onClick={() => changeFontSize('small')}
className={`px-1 py-0.5 text-xs font-medium rounded border transition-all duration-200 ${
          fontSize === 'small'
            ? 'bg-gray-300 text-gray-800 border-gray-400'
            : 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'
        }`}
title={t('accessibility.fontSize.decrease')}
>
A- </button>
<button
onClick={() => changeFontSize('xl')}
className={`px-1 py-0.5 text-xs font-medium rounded border transition-all duration-200 ${
          fontSize === 'xl'
            ? 'bg-gray-300 text-gray-800 border-gray-400'
            : 'bg-gray-100 text-gray-600 border-gray-300 hover:bg-gray-200'
        }`}
title={t('accessibility.fontSize.extraLarge')}
>
A </button>


  {/* Language Controls */}
  <button
    onClick={() => changeLanguage('en')}
    className={`px-2 py-0.5 text-xs font-medium rounded border transition-all duration-200 ${
      i18n.language === 'en'
        ? 'bg-orange-500 text-white border-orange-500'
        : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
    }`}
    title={t('accessibility.language.switchToEnglish')}
  >
    {i18n.language === 'mr' ? 'English' : 'English'}
  </button>
  <button
    onClick={() => changeLanguage('mr')}
    className={`px-2 py-0.5 text-xs font-medium rounded border transition-all duration-200 ${
      i18n.language === 'mr'
        ? 'bg-orange-500 text-white border-orange-500'
        : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
    }`}
    title={t('accessibility.language.switchToMarathi')}
  >
    मराठी
  </button>
</div>


);
}

export default LanguageSwitcher;
